import { useIntl } from 'react-intl';

import { LoggedInJiraBlueWaveTemplateCurrentProductUser } from '../components/logged-in-blue-wave-template-jira-current-product-user';

export const CurrentProductUser = () => {
	const { formatMessage } = useIntl();

	return (
		<LoggedInJiraBlueWaveTemplateCurrentProductUser
			productEditionText={formatMessage({
				id: 'WacSignupHeader.cloudPremium',
				defaultMessage: 'Cloud Premium',
			})}
		/>
	);
};
